import { render } from "./StockFilters.vue?vue&type=template&id=02b2540b"
import script from "./StockFilters.vue?vue&type=script&lang=js"
export * from "./StockFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__